import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ArticleEnums } from 'src/app/enum/article-enums';
import { InventoryEnums } from 'src/app/enum/inventory-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { ArticleModel } from 'src/app/models/archive/article.model';
import { EquipmentLogbookModel } from 'src/app/models/archive/equipment-logbook.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { CompanyModel } from 'src/app/models/management/company.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ConceptInvoicingService } from 'src/app/services/invoicing/concept-invoicing.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { TypeInventoryService } from 'src/app/services/global-services/type-inventory.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { AttachImagesArticleComponent } from '../attach-images-article/attach-images-article.component';

@Component({
  selector: 'app-register-article',
  templateUrl: './register-article.component.html',
  styleUrls: ['./register-article.component.scss'],
  standalone: false,
})
export class RegisterArticleComponent implements OnInit {

  @ViewChild('attachImages') attachImagesModalComponent?: CustomModalComponent | null = null;
  articleContract: ArticleModel = new ArticleModel();
  articleId: number = 0;
  componentAttachImages = AttachImagesArticleComponent;
  companyId: number = 0;
  disabledForm: boolean = false;
  equipmentLogbookModel: EquipmentLogbookModel = new EquipmentLogbookModel();
  formArticle: FormGroup = new FormGroup({});
  genericArticle: boolean = false;
  inputsForAttachImages$ = new BehaviorSubject<any>({
    articleContract: new ArticleModel(),
    permissionUpdatable: false,
    disabledForm: false
  });
  isOpened: string | undefined = undefined;
  listArticleGeneric: any[] = [];
  listFamily: any[] = [];
  listGroup: any[] = [];
  listInventoryUnit: any[] = [];
  listPurchaseConcept: any[] = [];
  listRentalUnit: any[] = [];
  listSubgroup: any[] = [];
  listTypeArticle: any[] = [];
  listTypeInventory: any[] = [];
  nameWindow: string = 'Captura Artículos';
  outputAttachImages$ = new Subject<any>();
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  stateArticle: string = '';
  severityState: string = 'success';
  subscription: Subscription;
  swMaintenanceOrder: boolean = false;
  swModuleOrder: boolean = false;
  swPurchaseModule: boolean = false;
  titleStateArticle: string = '';
  url: string = 'article';
  userAuthenticated: UserModel = new UserModel();

  constructor(
    private activatedRoute: ActivatedRoute,
    private articleService: ArticleService,
    private conceptInvoicingService: ConceptInvoicingService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private typeInventoryService: TypeInventoryService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
    private headerService: HeaderService
  ) {
    this.validateForm(this.articleContract);
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);

    await this.getPermission();
    this.activatedRoute.params.subscribe((params) => {
      this.articleId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
    this.subscription = this.outputAttachImages$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'updateArticleContract':
          this.articleContract = payload
          break;
        default:
          console.warn('Tipo de evento descononcido', type);
      }
    });
    this.headerService.setTitle(this.nameWindow);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(
      AuthenticationContants.keyWindowsOpenedLocalStorage
    );
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex((x) => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(
          AuthenticationContants.keyWindowsOpenedLocalStorage,
          JSON.stringify(windowsOpened)
        );
      }
    }
  }

  changeArticle() {
    const code = this.formArticle.get('code')?.value;
    if (code != '' && code > 0) {
      this.getArticleByCode(code);
    } else {
      this.articleId = 0;
      this.articleContract = new ArticleModel();
      this.validateForm(this.articleContract);
      this.getSubgroup(null);
      this.disabledForm = false;
      this.toastHandlerService.showToast(
        'error',
        'El artículo ingresado NO existe. Para crear una nueva, presione el botón "Nuevo".'
      );
    }
  }

  async changeStateArticle() {
    try {
      this.articleContract = await firstValueFrom(
        this.articleService.setActiveArticle(this.articleContract.articleId)
      );
      this.validateForm(this.articleContract);
      this.updateFormState(
        this.articleContract.active,
        this.articleContract.genericId
      );
      if (this.articleContract.active) {
        this.toastHandlerService.showToast(
          'success',
          'El artículo fue activado exitosamente.'
        );
      } else {
        this.toastHandlerService.showToast(
          'success',
          'El artículo fue inactivado exitosamente.'
        );
      }
    } catch (error) {
      console.error('Error al cambiar el estado del artículo.', error);
    }
  }

  async changeSwAffectsInventory(swAffectsInventory: boolean) {
    if (this.articleContract.articleId != 0 && this.articleContract.articleId != null) {
      const selectedTypeArticleId = this.formArticle.get('typeArticleId')?.value;
      if (selectedTypeArticleId == ArticleEnums.tipoServicio || selectedTypeArticleId == ArticleEnums.tipoReparación) {
        this.toastHandlerService.showToast(
          'error',
          'No es posible modificar el artículo, ya que el tipo que maneja no debe afectar el inventario'
        );
        setTimeout(() => this.formArticle.controls['swAffectsInventory'].patchValue(false), 100);
      } else if (selectedTypeArticleId == ArticleEnums.tipoEquipo ||
        selectedTypeArticleId == ArticleEnums.tipoAccesorio ||
        selectedTypeArticleId == ArticleEnums.tipoOtro) {
        this.toastHandlerService.showToast(
          'error',
          'No es posible modificar el artículo, ya que el tipo que maneja si debe afectar el inventario'
        );
        setTimeout(() => this.formArticle.controls['swAffectsInventory'].patchValue(true), 100);
      } else {
        if (!swAffectsInventory) {
          try {
            await firstValueFrom(this.articleService.validateBalances(this.articleId));
          } catch (error) {
            console.error(error);
            setTimeout(() => this.formArticle.controls['swAffectsInventory'].patchValue(true), 100);
          }
        }
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el artículo.'
      );
      setTimeout(() => this.formArticle.controls['swAffectsInventory'].patchValue(false), 100);
    }
  }

  changeSwPurchase() {
    setTimeout(() => this.updateSwRequiresPurchaseOrderState(), 100);
  }

  changeTypeArticleId() {
    const selectedTypeArticleId = this.formArticle.get('typeArticleId')?.value;
    const typeInventoryId = this.typeInventoryService.getTypeInventory(
      selectedTypeArticleId
    );
    this.formArticle.controls['typeInventoryId'].patchValue(typeInventoryId);
    if (typeInventoryId == InventoryEnums.otro) {
      setTimeout(
        () => this.formArticle.controls['typeInventoryId'].enable(), 100
      );
    } else {
      setTimeout(
        () => this.formArticle.controls['typeInventoryId'].disable(), 100
      );
    }
    if (selectedTypeArticleId == ArticleEnums.tipoServicio ||
      selectedTypeArticleId == ArticleEnums.tipoReparación) {
      this.formArticle.controls['swAffectsInventory'].patchValue(false);
    } else {
      this.formArticle.controls['swAffectsInventory'].patchValue(true);
    }
    if (selectedTypeArticleId != ArticleEnums.tipoEquipo) {
      this.formArticle.controls['swEquipmentLogbook'].patchValue(false);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.updateFormState(true, null);
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear artículos. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    this.articleId = 0;
    this.stateArticle = 'Activo';
    this.titleStateArticle = 'Cerrar';
    this.articleContract = new ArticleModel();
    this.validateForm(this.articleContract);
    this.getSubgroup(null);
    setTimeout(() => this.formArticle.enable(), 100);
    setTimeout(() => this.formArticle.controls['code'].disable(), 100);
    const rentalUnitId = this.listRentalUnit.find(
      (item) => item.label == 'Día'
    )!.value;
    setTimeout(() =>
      this.formArticle.controls['rentalUnitId'].patchValue(rentalUnitId)
    ); //Se asigna por defecto Uni.Alq en DIA
    const inventoryUnitId = this.listInventoryUnit.find(
      (item) => item.label == 'Unidad'
    )!.value;
    setTimeout(() =>
      this.formArticle.controls['inventoryUnitId'].patchValue(inventoryUnitId)
    ); //Se asigna por defecto Uni.Inv en UNIDAD
    this.disabledForm = false;
    this.updateFormState(true, null);
    this.location.replaceState(`/${this.url}/register`);
  }

  async deleteArticle() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para eliminar artículos. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar el artículo?`)) {
      try {
        await firstValueFrom(this.articleService.deleteArticle(this.articleContract.articleId));
        this.toastHandlerService.showToast(
          'success',
          'El artículo fue eliminado exitosamente.'
        );
        this.createNewRegister();
      } catch (error) {
        console.error('Error al eliminar el artículo.', error);
      }
    }
  }

  async handleInitialState() {
    if (this.articleId !== null && this.articleId !== 0) {
      await this.getArticleById();
    } else {
      this.createNewRegister();
    }
  }

  hasAnyImage(): boolean {
    const { image1, image2, image3 } = this.articleContract;
    return !!(image1 || image2 || image3);
  }

  async getAllLists() {
    try {
      const [
        typeArticles, articlesGeneric, typeInventories,
        families, subgroups, groups, rentalUnits, inventoryUnits, purchaseConcepts
      ] = await Promise.all([
        firstValueFrom(this.articleService.getAllTypeArticlesForSelectAsync()),
        firstValueFrom(this.articleService.getAllArticlesGenericForSelectAsync()),
        firstValueFrom(this.articleService.getAllTypeInventoriesForSelectAsync()),
        firstValueFrom(this.articleService.getAllFamiliesForSelectAsync()),
        firstValueFrom(this.articleService.getAllSubgroupsForSelectAsync()),
        firstValueFrom(this.articleService.getAllGroupsForSelectAsync()),
        firstValueFrom(this.articleService.getAllRentalUnitsForSelectAsync()),
        firstValueFrom(this.articleService.getAllInventoryUnitsForSelectAsync()),
        firstValueFrom(this.conceptInvoicingService.getAllPurchaseConceptsForSelectAsync()),
      ]);
      this.listTypeArticle = typeArticles;
      this.listArticleGeneric = articlesGeneric;
      this.listTypeInventory = typeInventories;
      this.listFamily = families;
      this.listSubgroup = subgroups;
      this.listGroup = groups;
      this.listRentalUnit = rentalUnits;
      this.listInventoryUnit = inventoryUnits;
      this.listPurchaseConcept = purchaseConcepts;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getArticleByCode(code: number) {
    try {
      this.articleContract = await firstValueFrom(
        this.articleService.getArticleByCode(code)
      );
      this.articleId = this.articleContract.articleId;
      this.validateForm(this.articleContract);
      setTimeout(() => this.formArticle.controls['code'].enable(), 100);
      this.getSubgroup(this.articleContract.subgroupId);
      this.updateFormState(this.articleContract.active, this.articleContract.genericId);
      this.location.replaceState(`/${this.url}/register/${this.articleId}`);
    } catch (error) {
      this.articleId = 0;
      this.articleContract = new ArticleModel();
      this.validateForm(this.articleContract);
      this.formArticle.controls['code'].patchValue(code);
      this.getSubgroup(null);
      this.disabledForm = true;
      console.error('Error al buscar el artículo por codigo.', error);
    }
  }

  async getArticleById() {
    try {
      this.articleContract = await firstValueFrom(this.articleService.getArticleById(this.articleId));
      this.validateForm(this.articleContract);
      this.getSubgroup(this.articleContract.subgroupId);
      this.updateFormState(this.articleContract.active, this.articleContract.genericId);
      setTimeout(() => this.formArticle.controls['code'].enable(), 100);
    } catch (error) {
      console.error('Error al buscar el artículo por id.', error);
    }
  }

  async getArticleByName() {
    const name: string = this.formArticle.get('name')?.value;
    if (name.toLocaleLowerCase() === this.articleContract.name.toLocaleLowerCase()) return;
    try {
      const response = await firstValueFrom(this.articleService.getArticleByName(name));
      if (response != null) {
        if (!(await this.confirmDialogService.confirm(
          `El artículo ${response.code} tiene el mismo nombre. ¿Desea continuar?`
        ))) {
          this.formArticle.controls['name'].patchValue('');
        }
      }
    } catch (error) {
      console.error('Error al buscar el artículo por nombre.', error);
    }
  }

  async getArticleGeneric(genericId: number | null) {
    if (genericId != null && genericId != 0) {
      try {
        const response = await firstValueFrom(this.articleService.getArticleById(genericId));
        this.formArticle.controls["genericId"].patchValue(genericId);
        this.formArticle.controls["typeArticleId"].patchValue(response.typeArticleId);
        this.formArticle.controls["typeInventoryId"].patchValue(response.typeInventoryId);
        this.formArticle.controls["rentalUnitId"].patchValue(response.rentalUnitId);
        this.formArticle.controls["inventoryUnitId"].patchValue(response.inventoryUnitId);
        this.formArticle.controls["familyId"].patchValue(response.familyId);
        this.formArticle.controls["saleValue"].patchValue(response.saleValue);
        this.formArticle.controls["replacementValue"].patchValue(response.replacementValue);
        this.getSubgroup(response.subgroupId);
      } catch (error) {
        this.formArticle.controls['genericId'].patchValue(null);
        this.disabledForm = false;
        setTimeout(() => this.formArticle.enable());
        setTimeout(() => this.formArticle.controls['groupId'].disable(), 150);
        setTimeout(() => this.formArticle.controls['accountingCostCenter'].disable(), 150);
        console.error('Error al buscar el artículo por id.', error);
      }
    }
  }

  async getButtonClick(buttonClick: any) {
    let code = this.formArticle.get('code')?.value;
    if (code == '' || code == null) code = 0;

    const actionMap: Record<string, () => Promise<ArticleModel>> = {
      first: async () =>
        await firstValueFrom(this.articleService.getFirstArticleByKeysAsync(false)),
      previus: async () =>
        await firstValueFrom(this.articleService.getPreviusArticleByKeysAsync(code, false)),
      next: async () =>
        await firstValueFrom(this.articleService.getNextArticleByKeysAsync(code, false)),
      last: async () =>
        await firstValueFrom(this.articleService.getLastArticleByKeysAsync(false)),
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) return;

    try {
      this.articleContract = await action();
      this.articleId = this.articleContract.articleId;
      this.validateForm(this.articleContract);
      this.updateFormState(this.articleContract.active, this.articleContract.genericId);
      this.location.replaceState(`/${this.url}/register/${this.articleId}`);
    } catch (error) {
      console.error(`Error al buscar el artículo (${buttonClick.target.id}).`, error);
    }
  }

  async getCompanyByUserAuthenticatedAsync() {
    const MAIN_BRANCH_BY_USER = (await firstValueFrom(
      this.userAuthenticatedService.companyObservable.pipe(
        filter((company) => company && company.companyId !== 0)
      )
    )) as CompanyModel;
    this.companyId = MAIN_BRANCH_BY_USER.companyId;
  }

  getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
        this.genericArticle = response.some(x => x.name === "ArticuloGenerico");
        this.swModuleOrder = response.some(x => x.name === "ModuloPedidos");
        this.swMaintenanceOrder = response.some(x => x.name === "OrdenesDeMantenimiento");
        this.swPurchaseModule = response.some(x => x.name === "ModuloCompras");
      });
      resolve(true);
    });
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find((x) => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(
        AuthenticationContants.keyWindowsOpenedLocalStorage,
        JSON.stringify(windowsOpened)
      );
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getAllLists(),
      this.getPermissionProfileByUrl(),
      this.getPermissionsForUserByWindow()
    ]);
    this.getUserAuthenticated();
    this.getGeneralParametersByCompany();
    this.getCompanyByUserAuthenticatedAsync();
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.permissionsUser = await firstValueFrom(
        this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Article)
      );
    } catch (error) {
      console.error('Error al cargar los permisos del usuario.', error);
    }
  }

  async getSubgroup(subgroupId: number | null) {
    if (subgroupId != 0 && subgroupId != null) {
      const subgroup = this.listSubgroup.find((x) => x.value == subgroupId);
      if (subgroup) {
        this.formArticle.controls["groupId"].patchValue(subgroup.groupId);
        this.formArticle.controls["subgroupId"].patchValue(subgroupId);
      } else {
        this.formArticle.controls['subgroupId'].patchValue(0);
        this.formArticle.controls['groupId'].patchValue(0);
      }
    } else {
      this.formArticle.controls['subgroupId'].patchValue(0);
      this.formArticle.controls['groupId'].patchValue(0);
    }
  }

  async getUserAuthenticated() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
    );
  }

  openAttachImages() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para adjuntar Imágenes, comuniquese con el administrador del sistema.`
      );
      return;
    }
    this.inputsForAttachImages$.next({
      articleContract: this.articleContract,
      permissionUpdatable: this.permissionUpdatable,
      disabledForm: this.disabledForm,
      showButtons: true
    });
    this.attachImagesModalComponent?.show();
  }

  async send() {
    this.validateFormControls();
    if (!this.formArticle.valid) {
      this.showValidationMessages();
      return;
    }
    this.formArticle.enable();
    const modelArticle = this.formArticle.value as ArticleModel;
    if (modelArticle.typeArticleId != ArticleEnums.tipoOtro)
      this.formArticle.controls['typeInventoryId'].disable();
    //Hago null, los campos que permiten ser nulos:
    if (modelArticle.alterCode == '') modelArticle.alterCode = null;
    if (modelArticle.alterCode2 == '') modelArticle.alterCode2 = null;
    if (modelArticle.observation == '') modelArticle.observation = null;
    if (modelArticle.imageArticle == '') modelArticle.imageArticle = null;
    //Regla de negocio: sin compra no puede requerir orden de compra
    if (!modelArticle.swPurchase) modelArticle.swRequiresPurchaseOrder = false;
    //Defin0 artículo como NO genérico
    modelArticle.swGeneric = false;
    if (this.articleId == 0) {
      try {
        this.articleContract = await firstValueFrom(this.articleService.createArticle(modelArticle));
        this.articleId = this.articleContract.articleId;
        this.validateForm(this.articleContract);
        setTimeout(() => this.formArticle.controls['code'].enable(), 100);
        this.getSubgroup(this.articleContract.subgroupId);
        this.updateFormState(this.articleContract.active, this.articleContract.genericId);
        this.toastHandlerService.showToast(
          'success',
          `El artículo fue creado exitosamente.`
        );
      } catch (error) {
        console.error('Error al crear el artículo.', error);
      }
    } else {
      this.articleContract.alterCode = modelArticle.alterCode;
      this.articleContract.alterCode2 = modelArticle.alterCode2;
      this.articleContract.name = modelArticle.name;
      this.articleContract.familyId = modelArticle.familyId;
      this.articleContract.groupId = modelArticle.groupId;
      this.articleContract.subgroupId = modelArticle.subgroupId;
      this.articleContract.typeArticleId = modelArticle.typeArticleId;
      this.articleContract.typeInventoryId = modelArticle.typeInventoryId;
      this.articleContract.rentalUnitId = modelArticle.rentalUnitId;
      this.articleContract.inventoryUnitId = modelArticle.inventoryUnitId;
      this.articleContract.active = modelArticle.active;
      this.articleContract.observation = modelArticle.observation;
      this.articleContract.occupancyPercentageReport = modelArticle.occupancyPercentageReport;
      this.articleContract.daysInConstructionSiteReport = modelArticle.daysInConstructionSiteReport;
      this.articleContract.swAffectsInventory = modelArticle.swAffectsInventory;
      this.articleContract.imageArticle = modelArticle.imageArticle;
      this.articleContract.genericId = modelArticle.genericId;
      this.articleContract.swDirectDevolutionWorkshop = modelArticle.swDirectDevolutionWorkshop;
      this.articleContract.swEquipmentLogbook = modelArticle.swEquipmentLogbook;
      this.articleContract.equipmentLogbookId = modelArticle.equipmentLogbookId;
      this.articleContract.equipmentLogbookConsecutive = modelArticle.equipmentLogbookConsecutive;
      this.articleContract.weight = modelArticle.weight;
      this.articleContract.areaM2 = modelArticle.areaM2;
      this.articleContract.replacementValue = modelArticle.replacementValue;
      this.articleContract.saleValue = modelArticle.saleValue;
      this.articleContract.minorRepairValue = modelArticle.minorRepairValue;
      this.articleContract.mayorRepairValue = modelArticle.mayorRepairValue;
      this.articleContract.cleaningValue = modelArticle.cleaningValue;
      this.articleContract.accountingCostCenter = modelArticle.accountingCostCenter;
      this.articleContract.swPurchase = modelArticle.swPurchase;
      this.articleContract.swSale = modelArticle.swSale;
      this.articleContract.swRequiresPurchaseOrder = modelArticle.swRequiresPurchaseOrder;
      this.articleContract.conceptInvoicingId = modelArticle.conceptInvoicingId;
      try {
        this.articleContract = await firstValueFrom(this.articleService.updateArticle(this.articleContract));
        this.toastHandlerService.showToast(
          'success',
          `El artículo fue modificado exitosamente.`
        );
        this.updateFormState(
          this.articleContract.active,
          this.articleContract.genericId
        );
      } catch (error) {
        console.error('Error al actualizar el artículo.', error);
      }
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      code: {
        required: 'El campo Código es obligatorio.'
      },
      alterCode: {
        maxlength: 'El campo Código Alterno no puede exceder los 20 caracteres.'
      },
      alterCode2: {
        maxlength: 'El campo Código Alterno 2 no puede exceder los 20 caracteres.'
      },
      typeArticleId: {
        required: 'El campo Tipo Artículo es obligatorio.',
        min: 'El campo Tipo Artículo es obligatorio.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El campo Nombre no puede exceder los 150 caracteres.'
      },
      typeInventoryId: {
        required: 'El campo Tipo Inventario es obligatorio.'
      },
      familyId: {
        required: 'El campo Familia es obligatorio.'
      },
      groupId: {
        required: 'El campo Grupo es obligatorio.',
        min: 'El campo Grupo es obligatorio.'
      },
      subgroupId: {
        required: 'El campo Subgrupo es obligatorio.',
        min: 'El campo Subgrupo es obligatorio.'
      },
      rentalUnitId: {
        required: 'El campo Und.Med.Alq. es obligatorio.',
        min: 'El campo Und.Med.Alq. es obligatorio.'
      },
      inventoryUnitId: {
        required: 'El campo Und.Med.Inv. es obligatorio.',
        min: 'El campo Und.Med.Inv. es obligatorio.'
      },
      observation: {
        maxlength: 'El campo Observaciones no puede exceder los 1000 caracteres.'
      },

      weight: {
        required: 'El campo Peso kg es obligatorio.',
        max: 'El campo Peso kg no puede exceder los 999999.99.'
      },
      areaM2: {
        required: 'El campo Área m2 es obligatorio.',
        max: 'El campo Área m2 no puede exceder los 999999.99.'
      },
      replacementValue: {
        required: 'El campo Vr.Reposición es obligatorio.'
      },
      saleValue: {
        required: 'El campo Vr.Venta es obligatorio.'
      },
      cleaningValue: {
        required: 'El campo Vr.Limpieza es obligatorio.'
      },
      minorRepairValue: {
        required: 'El campo Repar. Menor es obligatorio.'
      },
      mayorRepairValue: {
        required: 'El campo Repar. Mayor es obligatorio.'
      },
      accountingCostCenter: {
        maxlength: 'El campo C.Costo Contable no puede exceder los 50 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formArticle.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async swEquipmentLogbookUpdate(swEquipmentLogbook: boolean) {
    if (swEquipmentLogbook && this.articleId != 0 && this.articleId != null) {
      if (this.articleContract.swGeneric) {
        this.toastHandlerService.showToast(
          'error',
          `El artículo es generico. No se puede crear una hoja de vida a un artículo generico.`
        );
        setTimeout(() =>
          this.formArticle.controls['swEquipmentLogbook'].patchValue(!swEquipmentLogbook), 100
        );
        return;
      }
      if (this.formArticle.get('typeArticleId')!.value != ArticleEnums.tipoEquipo &&
        this.formArticle.get('typeArticleId')!.value != ArticleEnums.tipoAccesorio) {
        this.toastHandlerService.showToast(
          'error',
          `No se puede crear una hoja de vida a un artículo de tipo diferente a equipo o accesorio.`
        );
        setTimeout(
          () => this.formArticle.controls['swEquipmentLogbook'].patchValue(!swEquipmentLogbook), 100
        );
        return;
      }
      const hasQuantity = await firstValueFrom(
        this.articleService.validateBalancesByEquipmentLogbook(this.articleId)
      );
      if (hasQuantity) {
        this.toastHandlerService.showToast(
          'error',
          `El artículo tiene más de una cantidad en almacén, los equipos con hoja de vida solo pueden tener una cantidad.`
        );
        setTimeout(() =>
          this.formArticle.controls['swEquipmentLogbook'].patchValue(!swEquipmentLogbook), 100
        );
        return;
      }
    }
  }

  updateFormState(state: boolean, code: number | null) {
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formArticle.disable(), 100);
      setTimeout(() => this.formArticle.controls['code'].enable(), 100);
      return;
    }
    if (state) {
      this.stateArticle = 'Activo';
      this.titleStateArticle = 'Cerrar';
      this.severityState = 'success';
      this.disabledForm = false;
      if (code != null) {
        setTimeout(() => this.formArticle.enable());
        setTimeout(() => this.formControlStateService.setControlState(this.formArticle, [
          'typeInventoryId', 'familyId', 'subgroupId', 'groupId', 'rentalUnitId',
          'inventoryUnitId', 'saleValue', 'replacementValue', 'accountingCostCenter'
        ], false), 100);
        if (this.articleContract.articleId === 0) {
          setTimeout(() => this.formArticle.controls['code'].disable(), 100);
        }
        setTimeout(() => this.updateSwRequiresPurchaseOrderState(), 150);
        return;
      }
      setTimeout(() => this.formArticle.enable(), 100);
      this.articleContract.typeArticleId != ArticleEnums.tipoOtro
        ? setTimeout(() => this.formArticle.controls['typeInventoryId'].disable(), 100)
        : setTimeout(() => this.formArticle.controls['typeInventoryId'].enable(), 100);
    } else {
      this.disabledForm = true;
      this.stateArticle = 'Inactivo';
      this.titleStateArticle = 'Abrir';
      this.severityState = 'danger';
      setTimeout(() => this.formArticle.disable(), 100);
      setTimeout(() => this.formArticle.controls['code'].enable(), 100);
    }
    if (this.articleContract.articleId == 0)
      setTimeout(() => this.formArticle.controls['code'].disable(), 150);
    setTimeout(() => this.formArticle.controls['groupId'].disable(), 150);
    setTimeout(() => this.formArticle.controls['accountingCostCenter'].disable(), 150);
    setTimeout(() => this.updateSwRequiresPurchaseOrderState(), 150);
  }

  updateSwRequiresPurchaseOrderState() {
    const swPurchaseControl = this.formArticle.get('swPurchase');
    const requiresControl = this.formArticle.get('swRequiresPurchaseOrder');
    if (!swPurchaseControl || !requiresControl) return;
    if (swPurchaseControl.enabled && swPurchaseControl.value) {
      requiresControl.enable({ emitEvent: false });
    } else {
      if (!swPurchaseControl.value) {
        requiresControl.patchValue(false, { emitEvent: false });
      }
      requiresControl.disable({ emitEvent: false });
    }
  }

  async validateArticleGeneric(articleId: number | null) {
    if (this.articleId == 0) {
      await this.getArticleGeneric(articleId);
      this.updateFormState(this.articleContract.active, articleId);
    } else if (await this.confirmDialogService.confirm(
      'Los datos del artículo se van a reemplazar. ¿Realmente desea continuar?'
    )) {
      if (articleId != null && articleId != 0) {
        await this.getArticleGeneric(articleId);
        this.updateFormState(this.articleContract.active, articleId);
      } else {
        this.formArticle.controls['genericId'].patchValue(null);
        this.formArticle.controls['typeArticleId'].patchValue(0);
        this.formArticle.controls['typeInventoryId'].patchValue(0);
        this.formArticle.controls['rentalUnitId'].patchValue(0);
        this.formArticle.controls['inventoryUnitId'].patchValue(0);
        this.formArticle.controls['saleValue'].patchValue(null);
        this.formArticle.controls['replacementValue'].patchValue(null);
        this.getSubgroup(null);
        setTimeout(() => this.formArticle.enable(), 100);
        this.disabledForm = false;
        this.updateFormState(this.articleContract.active, null);
      }
    } else {
      this.formArticle.controls["genericId"].patchValue(this.articleContract.genericId);
    }
  }

  validateForm(article: ArticleModel) {
    this.formArticle = this.formBuilder.group({
      code: [article.code],
      alterCode: [article.alterCode, [Validators.maxLength(20)]],
      alterCode2: [article.alterCode2, [Validators.maxLength(20)]],
      name: [article.name, [Validators.required, Validators.maxLength(300)]],
      familyId: [article.familyId, [Validators.required, Validators.min(1)]],
      groupId: [article.groupId, [Validators.required, Validators.min(1)]],
      subgroupId: [article.subgroupId, [Validators.required, Validators.min(1)]],
      typeArticleId: [article.typeArticleId, [Validators.required, Validators.min(1)]],
      typeInventoryId: [article.typeInventoryId, [Validators.required, Validators.min(1)]],
      rentalUnitId: [article.rentalUnitId, [Validators.required, Validators.min(1)],],
      inventoryUnitId: [article.inventoryUnitId, [Validators.required, Validators.min(1)]],
      active: [article.active, [Validators.required]],
      observation: [article.observation, [Validators.maxLength(1000)]],
      occupancyPercentageReport: [article.occupancyPercentageReport, [Validators.required]],
      daysInConstructionSiteReport: [article.daysInConstructionSiteReport, [Validators.required]],
      swAffectsInventory: [article.swAffectsInventory, [Validators.required]],
      genericId: [article.genericId],
      imageArticle: [article.imageArticle],
      swDirectDevolutionWorkshop: [article.swDirectDevolutionWorkshop],
      swEquipmentLogbook: [article.swEquipmentLogbook],
      swPurchase: [article.swPurchase],
      swSale: [article.swSale],
      swRequiresPurchaseOrder: [{ value: article.swRequiresPurchaseOrder, disabled: !article.swPurchase }],
      conceptInvoicingId: [article.conceptInvoicingId],
      weight: [article.weight, [Validators.required, Validators.min(0), Validators.max(999999.99)]],
      areaM2: [article.areaM2, [Validators.required, Validators.min(0), Validators.max(999999.99)]],
      replacementValue: [article.replacementValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      saleValue: [article.saleValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      minorRepairValue: [article.minorRepairValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      mayorRepairValue: [article.mayorRepairValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      cleaningValue: [article.cleaningValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      accountingCostCenter: [article.accountingCostCenter, [Validators.maxLength(50)]],
    });
  }

  validateFormControls() {
    Object.keys(this.formArticle.controls).forEach((key) => {
      const control = this.formArticle.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
